import React, { useEffect, useState } from "react";
import TalentSideMenu from "../../components/TalentSideMenu";
import noAvatar from "../../../assets/img/noAvatar.png";
import Dropdown from "../../components/Dropdown";
import BasicInformation from "./components/BasicInformation";
import DesiredConditions from "./components/DesiredConditions";
import NewsMarked from "./components/NewsMarked";
import Career from "./components/Career";
import TalentHeader from "components/TalentHeader";
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSnackbar } from "notistack";
import CustomToast from "components/CustomToast";
import {formatDate, formatName, formatYear, formatYearMonth, getAge, convertToFullDate, formatJoinLeaveCompanyDate, getAgeByYearMonthDay} from "utils/format";
import FullInformation from "./components/FullInformation";
import CustomButton from "components/CustomButton";
import Copyright from "../../components/Copyright";
import InfiniteScroll from "react-infinite-scroll-component";
import { LoadingIcon } from "../../components/Icons";
import CustomPagination from "../../components/CustomPagination";
import FileItem from "../../components/FileItem";
import {
  getTalentDetail, createStatus, getCareerInformation,
  getBookmarkedList, setCurrentPage, setCurrentPageLoading,
  getBookmarkedListMobile, setActionStatus, setActionName, setActiveTab, setChangeEmailStatus
} from "../../reducers/talentMypage";
import { currentUserActions } from '../../reducers/currentUser';
import InterestedJob from "./components/InterestedJob";
import ReceiveNewsEmail from "./components/ReceiveNewsEmail";
import { useNavigate } from "react-router-dom"
import IndustryExperience from "./components/IndustryExperience";
import DesiredWorkingStyle from "./components/DesiredWorkingStyle";
import DesiredWorkingPlace from "./components/DesiredWorkingPlace";
import { TALENT_FILE_TYPE, TALENT_TYPE } from '../../constants/index';
import CheckboxButton from "../../components/CheckboxButton";
import ResumePanel from "./components/ResumePanel";
import JobCV from "./components/JobCV";
import OtherFiles from "./components/OtherFiles";
import { downloadFileAttachment } from 'utils/util';
import i18n from 'i18next';

const MyPage = () => {
  enum OpenState {
    None = "None",
    BasicInformation = "BasicInformation",
    OtherInformation = "OtherInformation",
    DesiredCondition = "DesiredConditions",
    Career = "Career",
    FullInformation = "FullInformation",
    InterestedJob = "InterestedJob",
    IndustryExperience = "IndustryExperience",
    DesiredWorkingPlace = "DesiredWorkingPlace",
    DesiredWorkingStyle = "DesiredWorkingStyle",
    ReceiveNewsEmail = "ReceiveNewsEmail",
    Closed = "false",
    RESUME = "RESUME",
    CV = "CV",
    OTHER = "OTHER"
  }

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const currentUser = useSelector((state: any) => state.currentUser)
  const { first_name, last_name, id, company } = currentUser.talentInfo
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isOpen, setIsOpen] = useState<OpenState>(OpenState.None);
  const {
    actionName, message, success, actionStatus, isReloadPage,
    talent, changeJobOptions, bookmarkedItems,
    countItems, currentPage, pageSize, changeEmailStatus,
    bookmarkedItemsMobile, currentPageLoading, pageSizeLoading,
    totalResultsMobile, hasMore, activeTab, isReloadBookmarkList,
    professionOptions, industryOptions, workingStyleOptions, cityOptions
  } = useSelector((state: any) => state.talentMypage);
  const navigate = useNavigate();

  const handleClose = () => {
    setIsOpen(OpenState.Closed);
  };

  const handleOpen = (e: any) => {
    setIsOpen(e);
  };

  const changeJobStatus = (item: any) => {
    dispatch(createStatus({
        requestBody: {
          change_job_status_id: item?.id || null, 
          work_parttime_status_id: null, 
          profession_1_id: talent?.profession_1_id || null,
          profession_2_id: talent?.profession_2_id || null,
          profession_3_id: talent?.profession_3_id || null,
          industry_1_id: talent?.industry_1_id || null,
          industry_2_id: talent?.industry_2_id || null,
          industry_3_id: talent?.industry_3_id || null,
          working_style_1_id: talent?.working_style_1_id || null,
          working_style_2_id: talent?.working_style_2_id || null,
          working_style_3_id: talent?.working_style_3_id || null,
          preferred_city_1_id: talent?.preferred_city_1_id || null,
          preferred_city_2_id: talent?.preferred_city_2_id || null,
          preferred_city_3_id: talent?.preferred_city_3_id || null
        },
      }),
    );
  };

  const workPartTimeStatusFunction = (item: any) => {
    dispatch(createStatus({
        requestBody: {
          change_job_status_id: null, 
          work_parttime_status_id: item?.id || null, 
          profession_1_id: talent?.profession_1_id || null,
          profession_2_id: talent?.profession_2_id || null,
          profession_3_id: talent?.profession_3_id || null,
          industry_1_id: talent?.industry_1_id || null,
          industry_2_id: talent?.industry_2_id || null,
          industry_3_id: talent?.industry_3_id || null,
          working_style_1_id: talent?.working_style_1_id || null,
          working_style_2_id: talent?.working_style_2_id || null,
          working_style_3_id: talent?.working_style_3_id || null,
          preferred_city_1_id: talent?.preferred_city_1_id || null,
          preferred_city_2_id: talent?.preferred_city_2_id || null,
          preferred_city_3_id: talent?.preferred_city_3_id || null
        },
      }),
    );
  };

  const showToast = (title: any) => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast title={title} message={message} variant={success ? "success" : "error"}
          snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  const showToastCustom = (title: any, message: any, variant: any) => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast title={title} message={message} variant={variant}
          snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  const handleCloseOnEscKeyDown = (event:any) => {
    const activeElement = document.activeElement as HTMLElement | null;

    // Check if the active element is an input or textarea
    if (event.key === "Escape") {
      if (
        activeElement &&
        (activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA")
      ) {
        activeElement.blur(); // Defocus the input field
        return; // Stop further execution
      } else {
        // If no input field is focused, close the panel
        handleClose();
      }
    }
  };

  useEffect(() => {
    if (['BasicInformation', 'OtherInformation', 'DesiredConditions', 'Career'].includes(isOpen)) {
      window.addEventListener("keydown", handleCloseOnEscKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleCloseOnEscKeyDown);
    };
  }, [isOpen]);

  useEffect(() => {
    if (actionStatus === 'fulfilled') {
      switch(actionName) {
          case 'updateChangeJobStatus':
            showToast('メッセージ');
            break;
          case 'updateChange':
            if (isOpen !== "FullInformation") showToast('メッセージ');
            break;
          case 'setReason':
            showToast('メッセージ');
            break;
          case 'updateCareerInformation':
            if (isOpen !== "FullInformation") showToast('メッセージ');
            break;
          case 'setItemBookmark':
            showToast('メッセージ');
            break;
          case 'updateFullInformation':
            showToast('メッセージ');
            break;
          case 'fileUploadPosting':
            showToast('メッセージ');
            break;
          case 'fileUploadUpdating':
            showToast('メッセージ');
            break;
          case 'fileUploadDeleting':
            showToast('メッセージ');
            break;
          default:
            break;
      }
      dispatch(setActionName(""));
      dispatch(setActionStatus("ide"));
    }
  }, [actionStatus, actionName]);

  useEffect(() => {
    dispatch(getTalentDetail(""));
    dispatch(currentUserActions.getCurrentUser({navigate, view: 'talent'}));
  }, [isReloadPage]);

  useEffect(() => {
    dispatch(getBookmarkedList({page:currentPage, pageSize:pageSize}));
  }, [currentPage, isReloadBookmarkList]);

  useEffect(() => {
    dispatch(getBookmarkedListMobile({page:currentPageLoading, pageSize:pageSizeLoading}));
  }, [currentPageLoading, isReloadBookmarkList]);

  const handleChangePage = (page, pageSize) => {
    dispatch(setCurrentPage(page));
  };

  const fetchData = () => {
    setTimeout(() => {
      dispatch(setCurrentPageLoading(parseInt(currentPageLoading) + 1));
    }, 800);
  };

  useEffect(() => {
    if(!changeEmailStatus) {
      return
    }
    if(changeEmailStatus.result && changeEmailStatus.message) {
      showToastCustom('メッセージ', '新しいアドレスにメールを送付しました。<br>ご確認ください。', 'success')
      dispatch(setChangeEmailStatus({ result: true, message: "" }));
      return
    }
    if(!changeEmailStatus.result && changeEmailStatus.message) {
      showToastCustom('メッセージ', changeEmailStatus.message, 'error')
      dispatch(setChangeEmailStatus({ result: true, message: "" }));
      return
    }    
  }, [changeEmailStatus]);

  const renderTalentInfo = (id1, id2, id3, options) => {
    let res = '';
    if(!id1 && !id2 && !id3) {
      return 'ー';
    } else {
      if(Array.isArray(options) && options.length > 0) {
        if(id1) {
          const item1 = options.find((item:any) => item?.id === id1);
          res += `${item1?.name} ` || ''
        }
        if(id2) {
          const item2 = options.find((item:any) => item?.id === id2);
          res += ` ${id1 && '>'} ${item2?.name}` || ''
        } else {
          res += ' > ー'
        }
        if(id3) {
          const item3 = options.find((item:any) => item?.id === id3);
          res += ` ${(id1 || id2) && '>'} ${item3?.name}` || ''
        } else {
          res += ' > ー'
        }
      }
    }
    return res;
  }

  const renderOtherInfo = (itemId, options) => {
    if(options && Array.isArray(options) && options.length > 0 && itemId) {
      const item = options.find((item:any) => item?.id === itemId);
      return item?.name || 'ー';
    }
  }

  const handleDownloadFileAttachment = async (url: string, filename?: string) => {
    try {
      await downloadFileAttachment(url, filename);
    } catch (error) {
      showToastCustom("メッセージ", i18n.t('MSG_GLOBAL_FILE_NOT_EXIST_OR_DELETED'), "error");
    }
  };

  return (
    <div className="h-dvh bg-alu-base md:bg-body">
      <TalentHeader productNameMob="マイページ" />
      <div className={`${
          isOpen === "FullInformation" ? "hidden" : ""
        } md:h-auto md:mb-0 md:pb-0 md:mt-6 md:px-6 flex gap-6 relative md:bg-body`}>
        <TalentSideMenu />
        <div className="flex-1 min-w-0 mb-[65px] md:mb-0 md:pb-0">
          <h1 className="ml-4 text-xl font-bold leading-[1.875rem] alu-text-base-2 hidden md:block">
            マイページ
          </h1>
          <div className="mt-0 md:mt-4">
            <div className="md:rounded-2xl pb-0 bg-white alu-section-box-shadow md:border-b md:alu-border">
              <div className={`px-4 py-4 pb-[7px] md:px-6 flex gap-6 rounded-2xl ${isOpen === "BasicInformation" ? "outline outline-1 outline-[#FF861A]" : ""}`}>
                <div className="flex gap-4 lg:w-[540px]">
                  <img src={talent?.avatar ? talent?.avatar : noAvatar} alt="Avatar" className="shrink-0 w-20 h-20 rounded-full object-cover" />
                  <div className="w-full relative">
                    <div className="w-full">
                      <div className="flex items-center gap-8 justify-between md:justify-start mb-2">
                        <p className="alu-text-base-2 text-2xl font-bold max-w-[12.5rem] break-words">{formatName(first_name, last_name)}</p>
                        {(isOpen === "None" || isOpen === "false") && <CustomButton
                          customStyle="hidden md:block shrink-0"
                          variant="text"
                          onClick={() => handleOpen("BasicInformation")}
                        >
                          編集
                        </CustomButton>}
                        <CustomButton
                          customStyle="md:hidden shrink-0"
                          variant="text"
                          onClick={() => handleOpen("FullInformation")}
                        >
                          編集
                        </CustomButton>
                      </div>
                      <div className="w-full inline-flex mb-1 md:mb-2 gap-2">
                        <span className="w-20 shrink-0 alu-text-base-1 text-sm whitespace-nowrap">生年月日</span>
                        <span className="alu-text-base-2 text-sm">{convertToFullDate(talent?.birth_year, talent?.birth_month, talent?.birth_day, false)}</span>
                      </div>
                      <div className="w-full inline-flex mb-1 md:mb-2 gap-2">
                        <span className="w-20 shrink-0 alu-text-base-1 text-sm whitespace-nowrap">年齢</span>
                        <span
                          className="alu-text-base-2 text-sm">{getAgeByYearMonthDay(talent?.birth_year, talent?.birth_month, talent?.birth_day)}</span>
                      </div>
                      <div className="w-full inline-flex mb-1 md:mb-2 gap-2">
                        <span className="w-20 shrink-0 alu-text-base-1 text-sm whitespace-nowrap">居住地</span>
                        <span
                          className="alu-text-base-2 text-sm">{talent?.city || 'ー'}</span>
                      </div>
                      <div className="w-full inline-flex mb-1 md:mb-2 gap-2">
                        <span className="w-20 shrink-0 alu-text-base-1 text-sm whitespace-nowrap">性別</span>
                        <span
                          className="alu-text-base-2 text-sm">{talent?.gender?.name || 'ー'}</span>
                      </div>
                      {talent?.last_company?.type?.value == TALENT_TYPE.ALUMNI && <div className="w-full inline-flex mb-1 md:mb-2 gap-2">
                        <span className="w-20 shrink-0 alu-text-base-1 text-sm whitespace-nowrap">最終部署</span>
                        <span
                          className="alu-text-base-2 text-sm">{talent?.last_company?.department ? talent?.last_company?.department : 'ー'}</span>
                      </div>}
                      {talent?.last_company?.type?.value == TALENT_TYPE.ALUMNI && <div className="w-full inline-flex mb-1 md:mb-2 gap-2">
                        <span className="w-20 shrink-0 alu-text-base-1 text-sm whitespace-nowrap">在籍期間</span>
                        <span className="alu-text-base-2 text-sm">
                          {formatJoinLeaveCompanyDate(talent?.last_company?.join_company_year, talent?.last_company?.join_company_month, talent?.last_company?.leave_company_year, talent?.last_company?.leave_company_month)}
                        </span>
                      </div>}
                      <div className="w-full inline-flex gap-2">
                        <span className="w-20 shrink-0 alu-text-base-1 text-sm whitespace-nowrap">現職 / 職種</span>
                        <span
                          className="alu-text-base-2 text-sm">{talent?.current_career?.description || 'ー'} / {renderOtherInfo(talent?.profession_1_id, professionOptions) || 'ー'}</span>
                      </div>
                      
                    </div>
                  </div>
                </div>
                {/* desktop view */}
                <div className="hidden lg:block">
                  <div className="min-w-[13.5rem] mb-6">
                    <Dropdown
                      inputWidth="full"
                      extraLabel="転職意欲"
                      dropdownPosition="center"
                      type="border"
                      placeholder="ー"
                      options={changeJobOptions}
                      value={talent?.change_job_status}
                      onChange={(value: any) => { changeJobStatus(value); } }
                      customStyle="bg-alu-base font-bold !border-transparent"
                    />
                  </div>
                  <div className="min-w-[13.5rem]">
                    <Dropdown
                      inputWidth="full"
                      extraLabel="副業意欲"
                      dropdownPosition="center"
                      type="border"
                      placeholder="ー"
                      options={changeJobOptions}
                      value={talent?.work_part_time_status}
                      onChange={(value: any) => { workPartTimeStatusFunction(value); } }
                      customStyle="bg-alu-base font-bold !border-transparent"
                    />
                  </div>
                </div>
              </div>
              <div className="px-4 md:px-6 mt-[23px] mb-6 mx-4 md:mx-0 flex lg:hidden gap-6 justify-center md:justify-normal">
                <div className="min-w-[9.0625rem]">
                  <Dropdown
                    inputWidth="full"
                    extraLabel="副業意欲"
                    dropdownPosition="center"
                    type="border"
                    placeholder="ー"
                    options={changeJobOptions}
                    value={talent?.work_part_time_status}
                    onChange={(value: any) => { workPartTimeStatusFunction(value); } }
                    customStyle="bg-alu-base font-bold !border-transparent"
                  />
                </div>
                <div className="min-w-[9.0625rem]">
                  <Dropdown
                    inputWidth="full"
                    extraLabel="転職意欲"
                    dropdownPosition="center"
                    type="border"
                    placeholder="ー"
                    options={changeJobOptions}
                    value={talent?.change_job_status}
                    onChange={(value: any) => { changeJobStatus(value); } }
                    customStyle="bg-alu-base font-bold !border-transparent"
                  />
                </div>
              </div>
              <div className="flex gap-2 md:gap-4 mx-4 md:mx-6 pb-0 md:mt-[17px]">
                <button
                  onClick={() => dispatch(setActiveTab('profile'))}
                  className={`flex items-end justify-center w-[50%] md:w-[144px] py-1 md:py-3 px-2 md:px-4 text-sm tracking-[-0.28px] ${activeTab === 'profile' ? 'md:text-[#FF861A] text-[#343A3D] font-bold border-b-2 border-[#343A3D] md:border-[#FF861A]' : "alu-text-base-1"}`}>
                  <span className="min-w-[112px]">プロフィール</span>
                </button>
                <button
                  onClick={() => dispatch(setActiveTab('bookmark'))}
                  className={`flex items-end justify-center w-[50%] md:w-[144px] py-1 md:py-3 px-2 md:px-4 text-sm tracking-[-0.28px] ${activeTab === 'bookmark' ? 'md:text-[#FF861A] text-[#343A3D] font-bold border-b-2 border-[#343A3D] md:border-[#FF861A]' : "alu-text-base-1"}`}>
                  <span className="min-w-[112px]">ブックマーク</span>
                </button>
              </div>
            </div>
          </div>
          {activeTab === 'profile' && (
            <div className="bg-white md:bg-transparent">
              <div className={`${isOpen === "Career" ? "outline outline-1 outline-[#FF861A]" : ""} md:mt-4 md:rounded-2xl px-4 pt-6 md:px-6 md:py-6 bg-white md:alu-section-box-shadow md:border-b md:alu-border relative`}>
                <div className="w-full">
                  <div className="flex items-center gap-2 mb-4">
                    <p className="text-base alu-text-base-2 font-bold">キャリア</p>
                    <CustomButton
                      customStyle="hidden md:block"
                      variant="text"
                      onClick={() => handleOpen("Career")}
                    >
                      編集
                    </CustomButton>
                  </div>
                  <div className="flex flex-col flex-wrap gap-4" >
                    {(talent?.careers?.length > 0) ? (talent?.careers?.map((item: any, idx: any) => (
                      <div key={idx} className="inline-flex gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <mask id="mask0_13103_9765" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                            <rect width="24" height="24" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_13103_9765)">
                            <path d="M8 10C8 11.1 8.39167 12.0417 9.175 12.825C9.95833 13.6083 10.9 14 12 14C13.1 14 14.0417 13.6083 14.825 12.825C15.6083 12.0417 16 11.1 16 10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10ZM6 10C6 8.33333 6.58333 6.91667 7.75 5.75C8.91667 4.58333 10.3333 4 12 4C13.6667 4 15.0833 4.58333 16.25 5.75C17.4167 6.91667 18 8.33333 18 10C18 11.5 17.525 12.8042 16.575 13.9125C15.625 15.0208 14.4333 15.6917 13 15.925C13 15.925 12.3905 16 12 16C11.6095 16 11 15.925 11 15.925C9.56667 15.6917 8.375 15.0208 7.425 13.9125C6.475 12.8042 6 11.5 6 10Z" fill="#808080" />
                            <path d="M11 17H13V19H11V17Z" fill="#808080" />
                            <path d="M11 20H13V22H11V20Z" fill="#808080" />
                          </g>
                        </svg>
                        <div>
                          <p className="text-sm alu-text-base-2">{item?.description}</p>
                          <p className="text-xs alu-text-base-1">{formatYearMonth(item?.join_date)}~{item?.leave_date ? formatYearMonth(item?.leave_date) : '現在'}</p>
                        </div>
                      </div>
                    ))) : (
                      <p className="text-sm alu-text-base-2">ー</p>
                    )}
                  </div>
                </div>
              </div>

              {company && company?.talent_type && company?.talent_type != TALENT_TYPE.INTERNAL && <div className="flex flex-col md:flex-row md:gap-4">
                {["RESUME", "CV", "OTHER"].map((item) => {
                  let file = null;
                  const uploadedFiles = talent?.last_company?.uploaded_files || [];
                  if(uploadedFiles.length > 0) {
                    file = uploadedFiles.find((file: any) => file?.type === item);
                  }

                  return (
                    <div key={item} className={`flex-1 w-full min-w-0 ${isOpen === item ? "outline outline-1 outline-[#FF861A]" : ""} md:mt-4 md:rounded-2xl px-4 pt-6 md:px-6 md:py-6 bg-white alu-section-box-shadow md:border-b md:alu-border relative`}>
                      <div className="w-full min-w-0">
                        <div className="flex items-center gap-2 mb-2">
                          <p className="text-base alu-text-base-2 font-bold">{item === "RESUME" ? "履歴書" : item === "CV" ? "職務経歴書" : "その他のファイル"}</p>
                          <CustomButton
                            variant="text"
                            customStyle="hidden md:block"
                            onClick={() => handleOpen(item)}
                          >
                            編集
                          </CustomButton>
                        </div>
                        {file ? <FileItem file={file} onFileClick={() => handleDownloadFileAttachment(file?.file_path, file?.file_name)} displayBorder={false} mobileBorderOnly={true} /> : 'ー'}
                      </div>
                    </div>
                  )
                })}
              </div>}

              <div className="flex flex-col md:flex-row md:gap-4">
                <div className={`flex-1 ${isOpen === "DesiredConditions" ? "outline outline-1 outline-[#FF861A]" : ""} md:mt-4 md:rounded-2xl px-4 pt-6 md:px-6 md:py-6 bg-white alu-section-box-shadow md:border-b md:alu-border relative`}>
                  <div className="w-full">
                    <div className="flex items-center gap-2 mb-2">
                      <p className="text-base alu-text-base-2 font-bold">希望する条件</p>
                      <CustomButton
                        variant="text"
                        customStyle="hidden md:block"
                        onClick={() => handleOpen("DesiredConditions")}
                      >
                        編集
                      </CustomButton>
                    </div>
                    <p className="hidden md:block text-sm alu-text-base-2">{talent?.expected_condition ? talent?.expected_condition : 'ー'}</p>
                    <p className="md:hidden text-sm alu-text-base-2">{talent?.expected_condition ? talent?.expected_condition.split('|').map((item:any, index) => <p key={index}>{item}</p>) : 'ー'}</p>
                  </div>
                </div>
                <div className={`flex-1 ${isOpen === "DesiredWorkingPlace" ? "outline outline-1 outline-[#FF861A]" : ""} md:mt-4 md:rounded-2xl px-4 pt-6 md:px-6 md:py-6 bg-white alu-section-box-shadow md:border-b md:alu-border relative`}>
                  <div className="w-full">
                    <div className="flex items-center gap-2 mb-2">
                      <p className="text-base alu-text-base-2 font-bold">希望する勤務地</p>
                      <CustomButton
                        variant="text"
                        customStyle="hidden md:block"
                        onClick={() => handleOpen("DesiredWorkingPlace")}
                      >
                        編集
                      </CustomButton>
                    </div>
                    {!talent?.preferred_city_1_id && !talent?.preferred_city_2_id && !talent?.preferred_city_3_id ? <p className="text-sm alu-text-base-2">ー</p>
                    : <>
                      {talent?.preferred_city_1_id && <p className="text-sm alu-text-base-2">{renderOtherInfo(talent?.preferred_city_1_id, cityOptions)}</p>}
                      {talent?.preferred_city_2_id && <p className="text-sm alu-text-base-2">{renderOtherInfo(talent?.preferred_city_2_id, cityOptions)}</p>}
                      {talent?.preferred_city_3_id && <p className="text-sm alu-text-base-2">{renderOtherInfo(talent?.preferred_city_3_id, cityOptions)}</p>}
                    </>
                    }
                  </div>
                </div>
                <div className={`flex-1 ${isOpen === "DesiredWorkingStyle" ? "outline outline-1 outline-[#FF861A]" : ""} md:mt-4 md:rounded-2xl px-4 pt-6 md:px-6 md:py-6 bg-white alu-section-box-shadow md:border-b md:alu-border relative`}>
                  <div className="w-full">
                    <div className="flex items-center gap-2 mb-2">
                      <p className="text-base alu-text-base-2 font-bold">希望する雇用形態</p>
                      <CustomButton
                        variant="text"
                        customStyle="hidden md:block"
                        onClick={() => handleOpen("DesiredWorkingStyle")}
                      >
                        編集
                      </CustomButton>
                    </div>
                    {!talent?.working_style_1_id && !talent?.working_style_2_id && !talent?.working_style_3_id ? <p className="text-sm alu-text-base-2">ー</p>
                    : <>
                      {<p className="text-sm alu-text-base-2">{talent?.working_style_1_id ? renderOtherInfo(talent?.working_style_1_id, workingStyleOptions) : 'ー'}</p>}
                      {<p className="text-sm alu-text-base-2">{talent?.working_style_2_id ? renderOtherInfo(talent?.working_style_2_id, workingStyleOptions) : 'ー'}</p>}
                      {<p className="text-sm alu-text-base-2">{talent?.working_style_3_id ? renderOtherInfo(talent?.working_style_3_id, workingStyleOptions) : 'ー'}</p>}
                    </>}
                  </div>
                </div>
              </div>

              <div className="flex md:gap-4 flex-col md:flex-row">
                <div className={`flex-1 ${isOpen === "InterestedJob" ? "outline outline-1 outline-[#FF861A]" : ""} md:mt-4 md:rounded-2xl px-4 pt-6 md:px-6 md:py-6 bg-white alu-section-box-shadow md:border-b md:alu-border relative`}>
                  <div className="w-full">
                    <div className="flex items-center gap-2 mb-2">
                      <p className="text-base alu-text-base-2 font-bold">経験した職種</p>
                      <CustomButton
                        variant="text"
                        customStyle="hidden md:block"
                        onClick={() => handleOpen("InterestedJob")}
                      >
                        編集
                      </CustomButton>
                    </div>
                    <p className="text-sm alu-text-base-2">
                      {renderTalentInfo(talent?.profession_1_id, talent?.profession_2_id, talent?.profession_3_id, professionOptions)}
                    </p>
                  </div>
                </div>
                <div className={`flex-1 ${isOpen === "IndustryExperience" ? "outline outline-1 outline-[#FF861A]" : ""} md:mt-4 md:rounded-2xl px-4 pt-6 md:px-6 md:py-6 bg-white alu-section-box-shadow md:border-b md:alu-border relative`}>
                  <div className="w-full">
                    <div className="flex items-center gap-2 mb-2">
                      <p className="text-base alu-text-base-2 font-bold">経験した業種</p>
                      <CustomButton
                        variant="text"
                        customStyle="hidden md:block"
                        onClick={() => handleOpen("IndustryExperience")}
                      >
                        編集
                      </CustomButton>
                    </div>
                    <p className="text-sm alu-text-base-2">
                      {renderTalentInfo(talent?.industry_1_id, talent?.industry_2_id, talent?.industry_3_id, industryOptions)}
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${isOpen === "receiveNewsEmail" ? "outline outline-1 outline-[#FF861A]" : ""} md:mt-4 md:rounded-2xl px-4 pt-6 md:px-6 md:py-6 pb-6 bg-white md:alu-section-box-shadow md:border-b md:alu-border relative`}>
                <div className="w-full">
                  <div className="flex items-center gap-2 mb-2">
                    <p className="text-base alu-text-base-2 font-bold">通知設定</p>
                    <CustomButton
                      variant="text"
                      customStyle="hidden md:block"
                      onClick={() => handleOpen("receiveNewsEmail")}
                    >
                      編集
                    </CustomButton>
                  </div>
                  <div className="flex flex-col gap-1 md:gap-2">
                    <p className="text-sm alu-text-base-2 md:p-1">{talent?.do_want_news_email ? '新着ニュース情報をメールで受け取る' : '新着ニュース情報をメールで受け取らない'}</p>
                    <p className="text-sm alu-text-base-2 md:p-1">{talent?.do_want_scout_email ? 'スカウトの通知をメールで受け取る' : 'スカウトの通知をメールで受け取らない'}</p>
                  </div>
                </div>
              </div>
              <div className="md:hidden mt-2 alu-section-box-shadow px-4">
                <Copyright view="talent" />
              </div>
            </div>
          )}
          {activeTab === 'bookmark' && (
            <div className={`bg-alu-base md:!bg-transparent ${bookmarkedItems.length > 0 || bookmarkedItemsMobile.length > 0 ? "pt-4" : "py-0"}`}>
              {/* Tablet and Desktop */}
              <div className="hidden md:block md:flex-1">
                <div className="flex flex-wrap gap-2 md:gap-6 px-4 md:px-0 mb-6">
                  <NewsMarked items={bookmarkedItems} />
                </div>
                {countItems > 0 &&
                  <div className="flex items-center justify-center">
                    <CustomPagination
                      total={countItems}
                      currentPage={currentPage}
                      pageSize={pageSize} 
                      onPageChange={handleChangePage}
                    />
                  </div>
                }
              </div>
              {/* Mobile */}
              <div className="block md:hidden md:flex-1">
                <InfiniteScroll
                  dataLength={bookmarkedItemsMobile.length}
                  next={fetchData}
                  hasMore={hasMore}
                  loader={<div className="flex justify-center p-2"><LoadingIcon /></div>}
                  scrollableTarget="scrollableDiv"
                  scrollThreshold={0.5}
                  className={bookmarkedItems.length > 0 || bookmarkedItemsMobile.length > 0 ? "pb-4" : ""}
                >
                  <div className="flex flex-col gap-4 px-4">
                    <NewsMarked items={bookmarkedItemsMobile} />
                  </div>
                </InfiniteScroll>
              </div>
              <div className="md:hidden mt-4 px-4">
                <Copyright view="talent" />
              </div>
            </div>
          )}
          
        </div>
        {isOpen && (
          <div className="hidden md:block fixed right-2 top-2 bottom-2 z-10">
            {isOpen == "BasicInformation" && (
              <BasicInformation onClose={handleClose} />
            )}
            {isOpen == "DesiredConditions" && (
              <DesiredConditions onClose={handleClose} />
            )}
            {isOpen == "Career" && (
              <Career onClose={handleClose} />
            )}
            {isOpen == "InterestedJob" && (
              <InterestedJob onClose={handleClose} />
            )}
            {isOpen == "IndustryExperience" && (
              <IndustryExperience onClose={handleClose} />
            )}
            {isOpen == "DesiredWorkingStyle" && (
              <DesiredWorkingStyle onClose={handleClose} />
            )}
            {isOpen == "DesiredWorkingPlace" && (
              <DesiredWorkingPlace onClose={handleClose} />
            )}
            {isOpen == "receiveNewsEmail" && (
              <ReceiveNewsEmail onClose={handleClose} />
            )}
            {isOpen == TALENT_FILE_TYPE.RESUME && (
              <ResumePanel onClose={handleClose} type={TALENT_FILE_TYPE.RESUME} />
            )}
            {isOpen == TALENT_FILE_TYPE.CV && (
              <ResumePanel onClose={handleClose} type={TALENT_FILE_TYPE.CV} />
            )}
            {isOpen == TALENT_FILE_TYPE.OTHER && (
              <ResumePanel onClose={handleClose} type={TALENT_FILE_TYPE.OTHER} />
            )}
          </div>
        )}
      </div>
      {isOpen === OpenState.FullInformation && (
        <div className="md:hidden absolute right-0 top-0 z-30 w-full min-h-full">
          {isOpen == "FullInformation" && (
            <FullInformation onClose={handleClose} />
          )}
        </div>
      )}
      <div className="hidden md:block pb-1">
        <Copyright view="talent" />
      </div>
    </div>
  );
};

export default MyPage;